import React from "react";
import { Tab, Tabs } from "react-bootstrap";

const EducationProfile = ({ tabData }) => {
  // Common image style for consistent sizing and responsiveness
  const imageContainerStyle = {
    aspectRatio: "4/3",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    borderRadius: "8px",
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
  };

  // Extract keys from tabData
  const tabKeys = Object.keys(tabData);

  // If no data is present for any tab, return null to hide the section
  if (tabKeys.length === 0) {
    return null;
  }

  // Determine the default active tab (first available tab with data)
  const defaultActiveKey = tabKeys[0];

  return (
    <div className="container">
      <div className="car">
        <div className="card-body p-0">
          <Tabs
            defaultActiveKey={defaultActiveKey}
            id="profile-tabs"
            className="mb-4"
            style={{ borderBottom: "1px solid #cacaca" }}
          >
            {tabKeys.map((key) => (
              <Tab key={key} eventKey={key} title={key}>
                {tabData[key].map((item, index) => (
                  <div key={index} className="row mt-3 align-items-center">
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 mb-md-0">
                      <div style={imageContainerStyle}>
                        <img
                          src={item.image.url}
                          alt={item.image.alt}
                          style={imageStyle}
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-8 col-lg-9">
                      <h5 className="mb-3">{item.title}</h5>
                      <p className="text-muted mb-0">{item.description}</p>
                    </div>
                  </div>
                ))}
              </Tab>
            ))}
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default EducationProfile;
